module.exports = __webpack_public_path__ + "static/015-slideshow-7072514ae349f0e8f03d86e42ef6089d.jpg";